import script from "./BarsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BarsChart.vue?vue&type=script&setup=true&lang=js"

import "./BarsChart.vue?vue&type=style&index=0&id=16c4fcfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c4fcfd"]])

export default __exports__